import React, {Fragment, useState} from 'react';
import Box from "@mui/material/Box";
import * as yup from "yup";
import {Controller, useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup/dist/yup";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Stack from '@mui/material/Stack';
import Alert from '@mui/material/Alert';

import LoadingBackdrop from "../common/LoadingBackdrop";
import AxiosApi from "../../config/axiosApi";
import {getAuthToken} from "../../lib/helpers";

const schema = yup.object({
    email: yup.string().email("Invalid email address!").required("Email is required!"),
}).required();

const StaffForm = () => {
    const formValues = {email: ''}
    const {handleSubmit, control, formState: {errors}, reset} = useForm({
        resolver: yupResolver(schema),
        defaultValues: formValues
    });
    const [message, setMessage] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleFormSubmit = async ({email}) => {
        setLoading(true);
        const url = "/account/addAdminRole";
        try {
            AxiosApi.defaults.headers.common["Authorization"] = "Bearer " + await getAuthToken();
            let response = await AxiosApi.post(url, {email});
            setMessage(response.data);
            setError(null);
        } catch (e) {
            setMessage(null);
            setError(e.response.data);
        }finally {
            setLoading(false);
        }
    }
    return (
        <Fragment>
            <LoadingBackdrop open={loading}/>
            <Typography id="modal-modal-title" variant="h6" component="h2">
                Staff Form
            </Typography>
            <Typography id="modal-modal-title" variant="body1">
                To add a staff, provided email must be pre-registered and active.
            </Typography>
            <Box component="form" noValidate sx={{mt: 1}} onSubmit={handleSubmit(handleFormSubmit)}>
                <FormControl fullWidth={true}>
                    <Controller
                        name="email"
                        control={control}
                        render={({field}) =>
                            <TextField
                                {...field}
                                margin="normal"
                                fullWidth
                                label="Staff Email Address"
                                autoComplete="email"
                                autoFocus
                                error={!!errors.email}
                                helperText={errors.email && errors.email?.message}
                            />}
                    />
                </FormControl>
                <Button
                    type="submit"
                    fullWidth={true}
                    variant="contained"
                    sx={{mt: 1}}
                >
                    Submit
                </Button>
            </Box>
            <Stack sx={{width: '100%', mt: 2}} spacing={2}>
                {error && <Alert severity="error">{error.message}</Alert>}
                {message && <Alert severity="success">{message.message}</Alert>}
            </Stack>
        </Fragment>
    );
};

export default StaffForm;